import { render } from "./Company.vue?vue&type=template&id=5789a698"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Company.vue?vue&type=style&index=0&id=5789a698&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script